import { Link, useNavigate } from "react-router-dom";
import { clearSessionToken } from "../auth";
import { useClubs } from "../ClubContext";

const navLink =
  "rounded-md border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 " +
  "hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700";

export function Header() {
  const navigate = useNavigate();
  const { me, clubs, activeClub, setActiveClubId, isActiveClubAdmin, isSuperAdmin } = useClubs();

  function handleSignOut() {
    clearSessionToken();
    navigate("/login", { replace: true });
  }

  return (
    <header className="border-b border-slate-200 border-t-4 border-t-brand-600 bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <div className="min-w-0">
          <Link to="/" className="inline-block" aria-label={`${activeClub?.clubName ?? "Club Manager"} — home`}>
            {/* Per-club logo once club branding ships; until then the club's
                own name, which beats showing one club's logo to every club. */}
            {activeClub?.logoUrl ? (
              <img src={activeClub.logoUrl} alt={activeClub.clubName} className="h-9 w-auto" />
            ) : (
              <span className="text-lg font-bold tracking-tight text-brand-700">
                {activeClub?.clubName ?? "Club Manager"}
              </span>
            )}
          </Link>
          {me && (
            <p className="mt-1 truncate text-xs text-slate-500">
              {me.user.name ?? me.user.email ?? "Signed in"}
              {activeClub && ` · ${activeClub.role}`}
              {activeClub?.viaSuperAdmin && (
                <span className="ml-1 rounded bg-amber-100 px-1.5 py-0.5 font-semibold text-amber-700">
                  super admin
                </span>
              )}
            </p>
          )}
        </div>
        <div className="flex shrink-0 items-center gap-2">
          {/* A switcher for one club is just noise — show it from two up. */}
          {clubs.length > 1 && (
            <select
              value={activeClub?.clubId ?? ""}
              onChange={(e) => setActiveClubId(e.target.value)}
              className="max-w-[12rem] rounded-md border border-slate-300 px-2 py-1.5 text-sm font-medium text-slate-700"
              aria-label="Active club"
            >
              {clubs.map((c) => (
                <option key={c.clubId} value={c.clubId}>
                  {c.clubName}
                </option>
              ))}
            </select>
          )}
          {isActiveClubAdmin && (
            <Link to="/schedules" className={navLink}>
              Schedules
            </Link>
          )}
          {isActiveClubAdmin && (
            <Link to="/teams" className={navLink}>
              Teams
            </Link>
          )}
          {isActiveClubAdmin && (
            <Link to="/members" className={navLink}>
              Members
            </Link>
          )}
          {isSuperAdmin && (
            <Link to="/clubs" className={navLink}>
              Clubs
            </Link>
          )}
          <Link to="/" className={navLink}>
            Games
          </Link>
          <button onClick={handleSignOut} className={navLink}>
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
